import AsyncStorage from '@react-native-async-storage/async-storage';
import { shared } from 'use-broadcast-ts';
import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

interface SettingsStore {
  uploadPhotosTutorialSeen: boolean;
  refCode: string;
  promoCode: string;
  askedAndroidPushNoticationsPermission: boolean;
  downloadAppModalSeen: boolean;
  partnerMode: boolean;
  subscriptionTutorialSeen: boolean;
  bankAccountTutorialSeen: boolean;
  fleetInsuranceAnnouncementDismissed: boolean;
  setDownloadAppModalSeen: (downloadAppModalSeen: boolean) => void;
  setAskedAndroidPushNoticationsPermission: (asked: boolean) => void;
  setUploadPhotosTutorialSeen: (uploadPhotosTutorialSeen: boolean) => void;
  setRefCode: (refCode: string) => void;
  setPromoCode: (promoCode: string) => void;
  setPartnerMode: (partnerMode: boolean) => void;
  setSubscriptionTutorialSeen: (subscriptionTutorialSeen: boolean) => void;
  setBankAccountTutorialSeen: (bankAccountTutorialSeen: boolean) => void;
  setFleetInsuranceAnnouncementDismissed: (dismissed: boolean) => void;
}

const useSettingsStore = create<SettingsStore>()(
  shared(
    persist(
      (set) => ({
        uploadPhotosTutorialSeen: false,
        refCode: '',
        promoCode: '',
        askedAndroidPushNoticationsPermission: false,
        downloadAppModalSeen: false,
        partnerMode: false,
        subscriptionTutorialSeen: false,
        bankAccountTutorialSeen: false,
        fleetInsuranceAnnouncementDismissed: false,
        setFleetInsuranceAnnouncementDismissed: (val: boolean) =>
          set({ fleetInsuranceAnnouncementDismissed: val }),
        setSubscriptionTutorialSeen: (val: boolean) =>
          set({ subscriptionTutorialSeen: val }),
        setBankAccountTutorialSeen: (val: boolean) =>
          set({ bankAccountTutorialSeen: val }),
        setPartnerMode: (val: boolean) => set({ partnerMode: val }),
        setDownloadAppModalSeen: (val: boolean) =>
          set({ downloadAppModalSeen: val }),
        setAskedAndroidPushNoticationsPermission: (val: boolean) =>
          set({ askedAndroidPushNoticationsPermission: val }),
        setUploadPhotosTutorialSeen: (val: boolean) =>
          set({ uploadPhotosTutorialSeen: val }),
        setRefCode: (val: string) => set({ refCode: val }),
        setPromoCode: (val: string) => set({ promoCode: val }),
      }),
      {
        name: 'eon-settings-storage',
        storage: createJSONStorage(() => AsyncStorage),
        partialize: (state) => ({
          downloadAppModalSeen: state.downloadAppModalSeen,
          partnerMode: state.partnerMode,
          subscriptionTutorialSeen: state.subscriptionTutorialSeen,
          bankAccountTutorialSeen: state.bankAccountTutorialSeen,
          fleetInsuranceAnnouncementDismissed:
            state.fleetInsuranceAnnouncementDismissed,
        }),
      }
    ),
    { name: 'settings-store-channel' }
  )
);

export default useSettingsStore;
